module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "processCartModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Nemaksā degvielas piemaksu!\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui middle aligned grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui positive message"
  }, [_vm._v("\n          Izvēlies papildus kādu no simtiem pārtikas un saimniecības produktu, lai kopējais pirkuma grozs būtu vismaz 25 EUR.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui fluid green button",
    on: {
      "click": _vm.closeCartModal
    }
  }, [_vm._v("\n            Turpināt iepirkties\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui fluid custom_brown button",
    on: {
      "click": function($event) {
        return _vm.processCart(false)
      }
    }
  }, [_vm._v("\n            Noformēt grozu\n          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Pirkumu grozs")])], 1)]), _vm._v(" "), _c('cart-steps', {
    attrs: {
      "step": "1"
    }
  }), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('div', {
    staticClass: "ui attached segment",
    class: {
      loading: _vm.storeStatus.loading, loading: _vm.showLoading
    }
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui divided items"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "ui tiny image",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/good/' + item.link)
        }
      }
    }, [(item.images[0]) ? _c('img', {
      attrs: {
        "src": item.images[0].url
      }
    }) : _c('img', {
      attrs: {
        "src": 'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/' + item.good_id + '.jpg'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('router-link', {
      staticClass: "header",
      attrs: {
        "to": '/good/' + item.link
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [(item.has_promo_discount) ? _c('span', {
      staticClass: "cinema"
    }, [_vm._v("Cena "), _c('span', {
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v(_vm._s((item.price_without_discount_vat).toFixed(2)))]), _c('span', {
      staticStyle: {
        "color": "#21BA45"
      }
    }, [_vm._v(_vm._s(item.price_vat))]), _vm._v(" € gab."), (item.bail > 0) ? _c('span', [_vm._v(", Drošības nauda " + _vm._s(item.bail) + " €")]) : _vm._e()]) : _c('span', {
      staticClass: "cinema"
    }, [_vm._v("Cena " + _vm._s(item.price_vat) + " € gab."), (item.bail > 0) ? _c('span', [_vm._v(", Drošības nauda " + _vm._s(item.bail) + " €")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('p', [_vm._v(_vm._s(item.description))])]), _vm._v(" "), _c('div', {
      staticClass: "extra"
    }, [_c('div', {
      staticClass: "ui grid"
    }, [_c('div', {
      staticClass: "fourteen wide column"
    }, [_c('div', {
      staticClass: "ui right floated"
    }, [_c('div', {
      staticClass: "ui left floated inline fields"
    }, [_c('label', {
      staticStyle: {
        "width": "85px",
        "text-align": "right"
      }
    }, [_vm._v("Pasūtīšu:   x")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.order),
        expression: "item.order"
      }],
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "type": "text",
        "placeholder": "skaits",
        "number": ""
      },
      domProps: {
        "value": item.order,
        "value": (item.order)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "order", $event.target.value)
        }, function($event) {
          _vm.showLoading = true;
          _vm.updateCartItemOrder(item);
        }]
      }
    })])]), _vm._v(" "), (item.isrentable == 1) ? _c('div', {
      staticClass: "ui left floated inline fields"
    }, [_c('label', {
      staticStyle: {
        "width": "85px",
        "text-align": "right"
      }
    }, [_vm._v("Atgriezīšu:   x")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.return),
        expression: "item.return"
      }],
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "type": "text",
        "placeholder": "skaits",
        "number": ""
      },
      domProps: {
        "value": item.return,
        "value": (item.return)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "return", $event.target.value)
        }, function($event) {
          _vm.showLoading = true;
          _vm.updateCartItemReturn(item);
        }]
      }
    })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "two wide column"
    }, [_c('button', {
      staticClass: "ui right floated grey icon button",
      on: {
        "click": function($event) {
          return _vm.removeItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "right trash icon"
    })])])]), _vm._v(" "), _vm._l((item.badges), function(badge) {
      return _c('div', {
        staticClass: "ui label",
        style: ({
          backgroundColor: '#' + badge.color,
          color: '#210404'
        })
      }, [_vm._v(_vm._s(badge.label))])
    })], 2)], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('button', {
    staticClass: "ui right floated custom_brown button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'goods'
        })
      }
    }
  }, [_vm._v("Pievienot citus produktus")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "ui right floated",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "gap": "5px",
      "flex-wrap": "wrap",
      "margin-bottom": "0"
    }
  }, [_c('label', [_vm._v("Atlaides kods:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cart.details.active_promo_code),
      expression: "cart.details.active_promo_code"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Kods"
    },
    domProps: {
      "value": _vm.cart.details.active_promo_code,
      "value": (_vm.cart.details.active_promo_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cart.details, "active_promo_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui custom_brown button",
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": function($event) {
        _vm.showLoading = true;
        _vm.activatePromoCode(_vm.cart.details.active_promo_code);
      }
    }
  }, [_vm._v("Aktivizēt")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui",
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "display": "none"
    },
    attrs: {
      "id": "promo_response"
    }
  }, [_vm._v("Test")])])]) : _vm._e(), _vm._v(" "), (_vm.showDateAndAddress && _vm.itemsInCart > 0 && _vm.cart.id && !_vm.nextAutoshipDelivery) ? _c('div', {
    staticClass: "ui attached segment"
  }, [_c('div', {
    staticClass: "ui icon message"
  }, [_c('img', {
    staticClass: "ui image small",
    attrs: {
      "src": require("../assets/autoship_logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.cart.details.savings >= 1) ? _c('div', {
    staticClass: "header"
  }, [_vm._v("\n                  Vēlies ietaupīt " + _vm._s(_vm.cart.details.savings) + " € par šo pasūtījumu?\n              ")]) : _c('div', {
    staticClass: "header"
  }, [_vm._v("\n                Vēlies ietaupīt laiku un naudu?\n              ")]), _vm._v(" "), _c('p', [_vm._v("Izveido regulāru AutoShip pasūtījumu un iegūsti atlaidi katram pasūtījumam.")]), _vm._v(" "), _c('button', {
    staticClass: "ui  green button",
    on: {
      "click": _vm.convertCartToAutoship
    }
  }, [_c('i', {
    staticClass: "icon plus"
  }), _vm._v("Pievienot AutoShip")])])])]) : _vm._e(), _vm._v(" "), (_vm.showDateAndAddress && _vm.itemsInCart > 0 && _vm.cart.id && _vm.nextAutoshipDelivery && _vm.nextAutoshipDelivery.status == 3) ? _c('div', {
    staticClass: "ui attached segment"
  }, [_c('div', {
    staticClass: "ui icon message"
  }, [_c('img', {
    staticClass: "ui image small",
    attrs: {
      "src": require("../assets/autoship_logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                Uzmanību!\n              ")]), _vm._v(" "), _c('p', [_vm._v("Jums ir aktīvs Autoship pasūtijums, kuru plānots piegādāt " + _vm._s(_vm.nextAutoshipDelivery.delivery_date) + "\n              "), _c('br'), _vm._v("Vēlaties pievienot izvēlētās preces tuvākajām Autoship pasūtījumam?")]), _vm._v(" "), _c('button', {
    staticClass: "ui custom_brown button",
    on: {
      "click": _vm.addGoodsToNearestOrder
    }
  }, [_c('i', {
    staticClass: "icon plus"
  }), _vm._v("Pievienot tuvākajam AutoShip")])])])]) : _vm._e(), _vm._v(" "), (_vm.itemsInCart > 0 && _vm.cart.id) ? _c('div', {
    staticClass: "ui secondary segment"
  }, [_c('div', {
    staticClass: "ui two column grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui column form"
  }, [(_vm.showDateAndAddress) ? _c('div', {
    staticClass: "ui field delivery_type_container"
  }, [_c('label', [_vm._v("Piegādes adrese")]), _vm._v(" "), (_vm.renderComponent) ? _c('select', {
    staticClass: "ui fluid dropdown",
    on: {
      "change": function($event) {
        _vm.showLoading = true;
        _vm.changeDeliveryAddressAndType($event.target.value, true);
      }
    }
  }, _vm._l((_vm.addressdeliverytype), function(item) {
    return _c('option', {
      domProps: {
        "value": item.address.id + '|' + item.deliveryType.id,
        "selected": (item.address.id == _vm.cart.address_id && item.deliveryType.id == _vm.cart.delivery_type_id) ? true : false
      }
    }, [_vm._v(_vm._s(item.deliveryType.title) + " - "), (item.address.id != 0) ? _c('span', [_vm._v(_vm._s(item.address.street)), (item.address.house_no != '') ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(item.address.house_no)), (item.address.flat_no != '') ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(item.address.flat_no)), (item.address.city_label != '') ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(item.address.city_label) + " - ")]) : _vm._e(), _vm._v(_vm._s(item.deliveryType.price) + "€")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Komentāri")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "notes",
      "rows": "4",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.cart.notes
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveCart('notes', $event.target.value);
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui column form"
  }, [(_vm.showDateAndAddress) ? _c('div', {
    staticClass: "ui field calendar calendar_container",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "start_date"
    }
  }, [_c('label', [_vm._v("Piegādes datums")]), _vm._v(" "), _c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Norādit datumu no"
    },
    domProps: {
      "value": _vm.cart.delivery_date
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.parcelmachines), function(item) {
    return (_vm.renderComponent) ? _c('div', {
      staticClass: "ui field parcel_machine_container",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'parcel_machines_' + item.deliveryType.id
      }
    }, [_c('label', [_vm._v("Pakomāts")]), _vm._v(" "), _c('select', {
      staticClass: "ui fluid dropdown",
      on: {
        "change": function($event) {
          _vm.showLoading = true;
          _vm.changeParcelMachine($event.target.value);
        }
      }
    }, _vm._l((item.deliveryType.parcel_machine_locations), function(m) {
      return _c('option', {
        domProps: {
          "value": m
        }
      }, [_vm._v(_vm._s(m))])
    }), 0)]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui list",
    staticStyle: {
      "text-align": "right",
      "margin-top": "30px"
    }
  }, [(_vm.cart.details.water_goods_price_vat > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("Pamatpreces: " + _vm._s(_vm.cart.details.water_goods_price_vat) + " €")]) : _vm._e(), _vm._v(" "), (_vm.cart.details.services_price_vat > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("Pakalpojums: " + _vm._s(_vm.cart.details.services_price_vat) + " €")]) : _vm._e(), _vm._v(" "), (_vm.cart.details.no_water_goods_price_vat > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("Citas preces: " + _vm._s(_vm.cart.details.no_water_goods_price_vat) + " €")]) : _vm._e(), _vm._v(" "), (_vm.cart.details.bail != 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    }
  }, [_c('span', {
    attrs: {
      "id": "bail",
      "data-content": "Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas"
    }
  }, [_vm._v("Drošības nauda: " + _vm._s(_vm.cart.details.bail) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.cart.details.deposit_amount != 0) ? _c('div', {
    staticClass: "item"
  }, [_c('span', {
    attrs: {
      "id": "deposit"
    }
  }, [_vm._v("Depozīts: " + _vm._s(_vm.cart.details.deposit_amount) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.cart.details.final_discount_vat != 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#21BA45"
    }
  }, [_c('span', [_vm._v("Atlaide: " + _vm._s(_vm.cart.details.final_discount_vat) + " €")])]) : _vm._e(), _vm._v(" "), ((_vm.cart.details.extra_delivery != 0) && (_vm.cart.details.water_goods_price_vat > 0)) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    }
  }, [_c('span', {
    attrs: {
      "id": "delivery",
      "data-html": "Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."
    }
  }, [_c('i', {
    staticClass: "info circle icon",
    attrs: {
      "data-html": "Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."
    }
  }), _vm._v("Mainīgā degvielas piemaksa: " + _vm._s(_vm.cart.details.extra_delivery) + " €")])]) : ((_vm.cart.details.extra_delivery != 0)) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    }
  }, [_c('span', {
    attrs: {
      "id": "delivery",
      "data-html": "Piegādes maksa netiks pievienota, ja pasūtīsiet preces vismaz 25 EUR vērtībā. Ja pasūtiet specifiskus smagus produktus (piem. malka, granulas), tad tiek piemērota papildus piegādes maksa par gab."
    }
  }, [_vm._v("Piegāde: " + _vm._s(_vm.cart.details.extra_delivery) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('b', [_vm._v("Kopsumma: " + _vm._s((_vm.cart.details.total_price_with_bail_and_vat - _vm.cart.details.final_discount_vat).toFixed(2)) + " €")])]), _vm._v(" "), (_vm.cart.details.bonus > 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#21BA45"
    }
  }, [_c('span', {
    attrs: {
      "id": "bonus_cart",
      "data-content": "Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei"
    }
  }, [_vm._v("Bonuss: + " + _vm._s(_vm.cart.details.bonus) + " € ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.cart.details.bail_to_refund > 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#21BA45"
    }
  }, [_c('span', {
    attrs: {
      "id": "bail_to_refund",
      "data-content": "Pēc pasūtījuma piegādes jums tiks atgriezta pārmaksātā Drošības nauda"
    }
  }, [_vm._v("Drošības naudas atmaksa: + " + _vm._s(_vm.cart.details.bail_to_refund) + " € ")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui right floated custom_brown animated button",
    class: {
      disabled: ((_vm.cart.delivery_date == '' && _vm.showDateAndAddress) || _vm.showLoading || _vm.storeStatus.loading), loading: _vm.showLoading || _vm.storeStatus.loading
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.processCart(true)
      }
    }
  }, [_c('div', {
    staticClass: "visible content"
  }, [_vm._v("Pasūtīt")]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })]) : _vm._e(), _vm._v(" "), (_vm.itemsInCart == 0 || !_vm.cart.id) ? _c('div', {
    staticClass: "ui attached segment"
  }, [_c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Pirkumu grozs ir tukšs!\n        ")]), _vm._v(" "), _c('p', [_vm._v("Pievieno vismaz vienu "), _c('router-link', {
    attrs: {
      "to": {
        name: 'goods'
      }
    }
  }, [_vm._v("preci")]), _vm._v(" savam pirkumu grozam")], 1)])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui field third-party-courier-warning",
    staticStyle: {
      "opacity": "0",
      "height": "0",
      "overflow": "hidden",
      "color": "red",
      "padding": "10px",
      "text-align": "justify",
      "line-height": "1.5em",
      "user-select": "none",
      "cursor": "pointer",
      "transition": "0.5s",
      "box-shadow": "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
      "border-radius": "5px"
    },
    attrs: {
      "onclick": "this.style.opacity = '0'; this.style.height = '0'; return false;"
    }
  }, [_vm._v("\n                        Lūdzu, ņemiet vērā, ka:"), _c('br'), _vm._v("\n                        1. Visu atbildību par preču piegādi un termiņiem uzņemas Jūsu izvēlētā kurjerfirma."), _c('br'), _vm._v("\n                        2. Netiek nodrošināts temperatūras režīms, tādēļ lūdzu rūpīgi izvērtējiet vai šāds piegādes veids ir piemērots Jūsu groza saturam."), _c('br'), _vm._v("\n                        3. Zemāk tiek norādīts nevis piegādes datums, bet datums, kad mēs nododam jūsu pasūtījumu kurjerfirmai. Tātad piegāde visdrīzāk būs 2-3 darba dienu laikā."), _c('br'), _vm._v("\n                        4. Ja groza vērtība pārsniegs 50.00 EUR, piegāde būs bezmaksas.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden content"
  }, [_c('i', {
    staticClass: "right arrow icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31c4411e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartPage.vue
// module id = 336
// module chunks = 1